import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const LandingNext = ({ handleSubmit: onSubmit }: any) => {
  const history = useHistory();

  const embebedURL = process.env.REACT_APP_DOMAIN_URL || '';

  const location = useLocation();

  const path = location.pathname.substring(1);
  const slicedPath = path.split('/');

  let suffix = 'login';
  let tokenPath = '';

  if (slicedPath.length == 2 && slicedPath[0] == 'recovery') {
    suffix = `verify`;
    tokenPath = `?t=${slicedPath[1]}`;
  }

  if (slicedPath.length == 2 && slicedPath[0] == 'change-password') {
    suffix = `${slicedPath[0]}`;
    tokenPath = `?t=${slicedPath[1]}`;
  }

  const isLogout = !!!localStorage.getItem('user');

  let iframeURL = `${embebedURL}/auth/${suffix}${tokenPath}`;
  iframeURL += iframeURL.includes('?')
    ? `&logout=${isLogout}`
    : `/?logout=${isLogout}`;

  const memoizedOnSubmit = useCallback(
    (response) => {
      onSubmit(response);
    },
    [onSubmit]
  );

  useEffect(() => {
    const handleMessage = (event) => {
      const response = event.data?.data || null;
      if (response) memoizedOnSubmit(response);
      if (event.data?.return == 'login') history.push('/');
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [history, memoizedOnSubmit, onSubmit]);

  return (
    <>
      <iframe
        title="my-frame"
        src={iframeURL}
        width={'100%'}
        height={'100%'}
      ></iframe>
    </>
  );
};

LandingNext.displayName = 'LandingNext';

export default LandingNext;
